import { render, staticRenderFns } from "./order-finish.vue?vue&type=template&id=faf20bd4&scoped=true&"
import script from "./order-finish.vue?vue&type=script&lang=js&"
export * from "./order-finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf20bd4",
  null
  
)

export default component.exports